import {
    DEALERAPPROVEREJECTDSR_FAILED,
    DEALERAPPROVEREJECTDSR_SUCCESS,
    RESET_DEALERAPPROVEREJECTDSR,
    LOADING_DEALERAPPROVEREJECTDSR,
    NETWORK_ERROR_DEALERAPPROVEREJECTDSR
} from '../types/index';

import { dealerServices } from "../../config/axios";


const resetDealerApproveRejectDsrList = () => {
    return { type: RESET_DEALERAPPROVEREJECTDSR };
};

const dealerApproveRejectDsrList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERAPPROVEREJECTDSR });
    await dealerServices
        .post("approveRejectDsr", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerApproveRejectDsrListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerApproveRejectDsrListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERAPPROVEREJECTDSR,
                payload: err
            });
        });
}

function dealerApproveRejectDsrListsuccess(data) {
    return {
        type: DEALERAPPROVEREJECTDSR_SUCCESS,
        payload: data
    };
}
function dealerApproveRejectDsrListFailed(data) {
    return {
        type: DEALERAPPROVEREJECTDSR_FAILED,
        payload: data
    };
}


export { resetDealerApproveRejectDsrList, dealerApproveRejectDsrList }